enum Mode {
    LOGIN = 0,
    MAIN = 1,
}

export default Mode;